var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: this.id > 0 ? "编辑" : "新增",
            visible: _vm.drawer,
            direction: "rtl",
            "show-close": true,
            "wrapper-closable": true,
            "append-to-body": true,
            wrapperClosable: false,
            "before-close": _vm.handleClose,
            size: "55%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.importTemplate.widgetList.length
            ? _c(
                "div",
                { staticClass: "mt14" },
                [
                  _vm.drawer
                    ? _c("VFormRender", {
                        ref: "preForm",
                        attrs: {
                          "form-json": _vm.importTemplate,
                          "form-data": _vm.testFormData,
                          "preview-state": true,
                          "option-data": _vm.testOptionData,
                          "global-dsv": _vm.designerDsv,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button from-foot-btn fix btn-shadow" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "el-btn",
                          attrs: { size: "small" },
                          on: { click: _vm.handleClose },
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.saveFn },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("default-page", {
                    attrs: { index: 16, "min-height": 420 },
                  }),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }